import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
const PIXEL_ID = '2088545771738527';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const metaWindow = window as Window & {
        fbq?: PixelFunction;
        _fbq?: PixelFunction;
      };
      if (!metaWindow.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as PixelFunction;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        metaWindow.fbq = pixel;
        metaWindow._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      metaWindow.fbq?.('init', PIXEL_ID);
      metaWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="nuraocvicv35">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="nvasltl5rjh6" />
      </noscript>
      <main className="min-h-screen w-full overflow-x-hidden bg-brand-light" data-id="element-2" data-mp="38b6kw4i7udz">
        <div className="mx-auto w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="3ucje3y95kjvu">
          <UrgencyBanner data-id="element-4" data-mp="d3cu5nj4soeg" />
          <Hero data-id="element-5" data-mp="d3wa4yp812pu" />
          <PainSection data-id="element-6" data-mp="d2bhxfqdpvv5" />
          <ModulesSection data-id="element-7" data-mp="851lhg4kojxt" />
          <BonusSection data-id="element-8" data-mp="86w7kxrkyi3h" />
          <PricingCard data-id="element-9" data-mp="86cqfj9r7xqi" />
          <Guarantee data-id="element-10" data-mp="3gle90gn0mze4" />
          <Testimonials data-id="element-11" data-mp="3gkuxpirvf992" />
          <FAQ data-id="element-12" data-mp="3gm65dtoft15g" />
          <FinalCTA data-id="element-13" data-mp="3glnxu0wbr0i8" />
          <Footer data-id="element-14" data-mp="3gj1qo2dcin0j" />
        </div>
      </main>
    </>;
}